import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { IAppLink } from "./models/IAppLink";

enum LinkType {
  Basic,
  Nested,
  Divider,
}

@Component({
  selector: "app-app-link",
  templateUrl: "./app-link.component.html",
  styleUrls: ["./app-link.component.scss"],
})
export class AppLinkComponent implements OnInit {
  @Input() appLink: IAppLink;
  @Output() appLinkClicked = new EventEmitter();

  public LinkType = LinkType;
  public linkType: LinkType;

  constructor() {
  }

  ngOnInit() {
    if (this.appLink.label === null) {
      this.linkType = LinkType.Divider;
    } else if (this.appLink.children && this.appLink.children.length > 0) {
      this.linkType = LinkType.Nested;
    } else {
      this.linkType = LinkType.Basic;
    }
  }
  linkClicked() {
    this.appLinkClicked.emit(null);
  }
}
